<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>New UoM Group</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" small text to="/inventory/uom-groups">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <!-- editor -->
        <editor :initial="dataItem" @data="save"></editor>
        <!-- end -->
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Editor from "../_components/editor.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    Editor,
  },
  computed: {
    ...mapGetters(["user"]),
  },
  data: () => ({
    dataItem: {},
  }),
  methods: {
    save(data) {
      const url = "/ougp";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          console.log(res, "uom group res");
          // self.$refs.snackbar.show("Item group created", "green");
          self.$router.push(`/uom-group/definition/${res.ResponseData.id}`);
        })
        .catch(() => {});
    },
  },
};
</script>